import { AlertCircle } from "lucide-react";

const ConfirmPrompt = ({
    visible,
    title = "Confirm",
    message = "Are you sure?",
    confirmText = "Confirm",
    cancelText = "Cancel",
    onConfirm,
    onCancel
}) => {
    if (!visible) return null;

    return (
        <div className="fixed inset-0 z-[2147483647] flex items-start justify-center bg-black/60 transition-all duration-300">
            <div className="mt-2 bg-white rounded-md shadow-xl w-[420px] max-w-[90%] p-6 text-left">
                {/* Header */}
                <div className="flex items-center mb-2">
                    <AlertCircle className="text-red-500 w-5 h-5 mr-2" />
                    <h3 className="font-semibold text-gray-900 text-base m-0">{title}</h3>
                </div>

                {/* Message */}
                <p className="text-gray-700 text-sm mb-5">{message}</p>

                {/* Buttons */}
                <div className="flex justify-end gap-2">
                    <button
                        type="button"
                        onClick={onCancel}
                        className="px-4 py-1.5 border border-gray-300 rounded-md bg-gray-100 hover:bg-gray-200 text-sm font-medium"
                    >
                        {cancelText}
                    </button>

                    <button
                        type="button"
                        onClick={onConfirm}
                        className="px-5 py-1.5 rounded-md bg-[#C62828] hover:bg-[#A61B1B] text-white text-sm font-medium"
                    >
                        {confirmText}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ConfirmPrompt;